/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropFollowStatus } from './DropFollowStatus';
import {
    DropFollowStatusFromJSON,
    DropFollowStatusFromJSONTyped,
    DropFollowStatusToJSON,
    DropFollowStatusToJSONTyped,
} from './DropFollowStatus';

/**
 * 
 * @export
 * @interface DropFollowStatusResponse
 */
export interface DropFollowStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DropFollowStatusResponse
     */
    isFollowing: boolean;
    /**
     * 
     * @type {DropFollowStatus}
     * @memberof DropFollowStatusResponse
     */
    status?: DropFollowStatus;
}



/**
 * Check if a given object implements the DropFollowStatusResponse interface.
 */
export function instanceOfDropFollowStatusResponse(value: object): value is DropFollowStatusResponse {
    if (!('isFollowing' in value) || value['isFollowing'] === undefined) return false;
    return true;
}

export function DropFollowStatusResponseFromJSON(json: any): DropFollowStatusResponse {
    return DropFollowStatusResponseFromJSONTyped(json, false);
}

export function DropFollowStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropFollowStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isFollowing': json['isFollowing'],
        'status': json['status'] == null ? undefined : DropFollowStatusFromJSON(json['status']),
    };
}

export function DropFollowStatusResponseToJSON(json: any): DropFollowStatusResponse {
    return DropFollowStatusResponseToJSONTyped(json, false);
}

export function DropFollowStatusResponseToJSONTyped(value?: DropFollowStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isFollowing': value['isFollowing'],
        'status': DropFollowStatusToJSON(value['status']),
    };
}

